import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import React, { useState, useEffect, useLayoutEffect } from 'react';
// @mui
import { Container, Stack, Typography } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// components
import ViewPost from '../components/NoticeComponents/ViewPost';
import ViewPostList from '../components/NoticeComponents/ViewPostList';
// mock
import PRODUCTS from '../_mock/products';
import PageHeader from '../components/sectionComponent/PageHeader';

// ----------------------------------------------------------------------

function createData(id, title, content, userName, userCompanyName, createdAt) {
  return { id, title, content, userName, userCompanyName, createdAt };
}

const rows = [
  createData('제목1', '제목1', '2023-02-01'),
  createData('제목1', '제목2', '2023-02-01'),
  createData('제목1', '제목3', '2023-02-01'),
  createData('제목1', '제목4', '2023-02-01'),
  createData('제목1', '제목5', '2023-02-01'),
];

export default function Notice() {
  const [openFilter, setOpenFilter] = useState(false);
  const [boardList, setBoardList] = useState([]);
  const [boardType, setBoardType] = useState('레인드롭');

  const [userType, setUserType] = useState('');

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const contentHandle = () => {
    console.log('dasd');
  };

  const sendData = {
    board_id: 23,
    page_number: 1,
    serch_query: '',
  };

  const fetchData = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_SERVER_URL}/boards/list`,
        method: 'post',
        data: sendData,
      });

      console.log('data', response.data[0][0]);
      const newBoardList = [];

      for (let i = 0; i < response.data[0].length; i += 1) {
        newBoardList.push({
          id: response.data[0][i].content_id,
          title: response.data[0][i].content_title,
          content: response.data[0][i].content_message,
          userName: response.data[0][i].user_name,
          userCompanyName: response.data[0][i].company_name,
          createdAt: response.data[0][i].created_at,
        });
      }

      setBoardList(newBoardList);
    } catch (error) {
      console.log('error', error);
    }
  };

  useLayoutEffect(() => {
    fetchData();
  }, []);

  const setBoardListType = (type) => {
    setBoardType(type);
  };

  return (
    <>
      <Helmet>
        <title> 공지사항 | RainDrop </title>
      </Helmet>
      <PageHeader data={'공지사항'} setBoardListType={setBoardListType} />

      {boardType === '레인드롭' && (
        <ViewPostList
          data={{
            board_id: 26,
            page_number: 1,
            serch_query: '',
          }}
        />
      )}
      {boardType === '슈가폴' && (
        <ViewPostList
          data={{
            board_id: 27,
            page_number: 1,
            serch_query: '',
          }}
        />
      )}

      {/* {viewPost && <ViewPost data={"contentid"} closeViewPost={CloseViewPost}/>} */}
    </>
  );
}
